"use client";

import type { HTMLAttributes, FC, Ref } from "react";
import type { RecipeVariants } from "@vanilla-extract/recipes";
import { mergeClasses } from "@huub-web/utils";

import { centeredStyle } from "./Center.css";
import type { ClassNameProp } from "../../props/ClassNameProp";
import type { ChildrenProp } from "../../props";

export type CenterProps = HTMLAttributes<HTMLDivElement> &
  ClassNameProp &
  ChildrenProp &
  RecipeVariants<typeof centeredStyle> & {
    grow?: boolean;
    /**
     * Ref forwarded to the root element
     */
    ref?: Ref<HTMLDivElement>;
  };

/**
 * Center component.
 */
export const Center: FC<CenterProps> = ({
  children,
  horizontal,
  grow,
  className,
  ref,
  ...props
}) => (
  <div
    ref={ref}
    className={mergeClasses(centeredStyle({ horizontal, grow }), className)}
    {...props}
  >
    {children}
  </div>
);
